import React from 'react';
import { NetworkInsights } from '@frontend/gql/social/graphql';
import { Card } from '@frontend/shadcn/components/ui/card';
import { TiktokIcon } from '@revfluence/fresh-icons/brands/esm';
import {
  TableHeader as TableHeaderComponent,
  TableHeaderSection,
  TableHeaderLayout,
  TableHeaderLabel,
} from '../table-header';
import { NetworkMetricsTable } from '../network-metrics-table';

interface TikTokMetricsCardProps {
  data?: NetworkInsights | null;
  socialDataReconciliation?: boolean;
}

export const TikTokMetricsCard = ({ data, socialDataReconciliation }: TikTokMetricsCardProps) => {
  return (
    <Card aria-label="TikTok Metrics">
      <TableHeaderComponent>
        <TableHeaderLayout>
          <TableHeaderSection>
            <TableHeaderLabel>
              <div className="flex items-center gap-2">
                <TiktokIcon className="h-5 w-5 text-[#000000]" />
                <span aria-live="polite">TikTok</span>
              </div>
            </TableHeaderLabel>
          </TableHeaderSection>
        </TableHeaderLayout>
      </TableHeaderComponent>
      <NetworkMetricsTable data={data} socialDataReconciliation={socialDataReconciliation} />
    </Card>
  );
};
